import { render } from "./Slider.vue?vue&type=template&id=254b02b4&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=254b02b4&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254b02b4"]])

export default __exports__